import React, { Component } from "react";
import { connect } from "react-redux";
import { notesList } from "../../_actions";
import ReportSmallIcon from "../../_icons/ReportSmallIcon";
import Moment from "react-moment";
import "./index.css";
import { Row, Col } from "react-bootstrap";
import FontAwesome from "react-fontawesome";

class ReportCard extends Component {
  renderList = list => {
    if (list && list.length > 0) {
      return list.map(obj => obj.name).join(", ");
    }

    return "All";
  };

  renderTitleRow = item => {
    return (
      <div className="row-title">
        <ReportSmallIcon className="small-icon" stroke="#111111" />
        {item.name}
      </div>
    );
  };

  renderSecondRow = item => {
    return (
      <Row>
        <Col md={4}>
          <div className="row-columns">
            <div className="card-datum">
              <span className="card-datum-name">Date</span>
              <span className="card-datum-value">
                <Moment format="DD MMM YYYY">{item.start_date}</Moment>
                {" - "}
                <Moment format="DD MMM YYYY">{item.end_date}</Moment>
              </span>
            </div>
          </div>
        </Col>
        <Col md={3}>
          <div className="row-columns">
            <div className="card-datum">
              <span className="card-datum-name">Precinct</span>
              <span className="card-datum-value">{this.renderList(item.precincts)}</span>
            </div>
          </div>
        </Col>
        <Col md={3}>
          <div className="row-columns">
            <div className="card-datum">
              <span className="card-datum-name">Discipline</span>
              <span className="card-datum-value">{this.renderList(item.disciplines)}</span>
            </div>
          </div>
        </Col>
        <Col md={2}>
          <div className="row-columns">
            <div className="card-datum">
              <span className="card-datum-name">Report Type</span>
              <span className="card-datum-value">{item.report_type_display}</span>
            </div>
          </div>
        </Col>
      </Row>
    );
  };

  renderActionColumn = item => {
    if (item.pdf_generation_status === "complete") {
      return (
        <a className="link" href={item.pdf_file} target="_blank">
          Download PDF
        </a>
      );
    }

    if (item.pdf_generation_status === "error") {
      return (
        <div className="errorMsg"><FontAwesome name="exclamation-circle" /> Error</div>
      );
    }

    return (
      <div>
        <div className="inlineLoading" />
        Generating PDF
      </div>
    );
  };

  render = () => {
    const { item } = this.props;

    return (
      <div className="mainReportPanel">
        <div className="reportPanel">
          <div className="content-column">
            <div>
              {this.renderTitleRow(item)}
              {this.renderSecondRow(item)}
            </div>
          </div>
          <div className="action-column">{this.renderActionColumn(item)}</div>
        </div>
      </div>
    );
  };
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  const { configList } = state.configuration;
  return {
    user,
    configList
  };
}

export default connect(
  mapStateToProps,
  { notesList }
)(ReportCard);



// WEBPACK FOOTER //
// ./src/_components/ReportCard/index.js